import React from "react";
import { Modal } from "../../Default/Index";
import { RoundedCloseButton } from "../../../Buttons/RoundedCloseButton/Index";
import { ReactComponent as Check } from "../../../../assets/svg/icons/CheckFull.svg";
import "./style.css";
import { ButtonOnlyTitle } from "../../../Buttons/ButtonOnlyTitle/Index";
import { useTranslation } from "react-i18next";

interface SuccessModalProps {
  visible: boolean;
  onClose: () => void;
  createNewTask: () => void;
  monitoringScreen: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  visible,
  onClose,
  createNewTask,
  monitoringScreen
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ zIndex: 910 }}>
      <Modal
        visible={visible}
        contentStyle={{
          padding: "60px",
          width: "600px",
          height: "auto",
          borderRadius: 25,
          position: "relative",
        }}
      >
        <header className="success__modal-header">
          <RoundedCloseButton onClick={() => onClose()} />
        </header>
        <main className="success__modal-main">
          <Check width={40} height={40} />
          <div className="success__modal-message">
            <h2>{t("taskCreation.completed")}</h2>
            <span>{t("taskCreation.success")}</span>
          </div>
        </main>
        <footer className="success__modal-button-container">
          <ButtonOnlyTitle title={t("taskCreation.createMore")} theme="light" onClick={() => createNewTask()}/>
          {/* <ButtonOnlyTitle title="Ir para tela de monitoramento" theme="info" onClick={() => monitoringScreen()}/> */}
        </footer>
      </Modal>
    </div>
  );
};
